import React from 'react';
import { FormDialog } from '../../../form-dialog/form-dialog';
import { IBulkEditResultSection } from './bulk-edit-results';

export interface ICourseBulkEditResultDialogComponentProps {
  title: string;
  sections: IBulkEditResultSection[];
  onClose: () => void;
}

export function CourseBulkEditResultDialogComponent({ title, sections, onClose }: ICourseBulkEditResultDialogComponentProps) {
  return (
    <FormDialog open title={title} confirmButtonText="Luk" onConfirmClick={onClose} onClose={onClose} maxWidth="sm" fullWidth>
      {sections.map(section => (
        <React.Fragment key={section.summary}>
          <p>{section.summary}</p>
          {section.skippedItems.length > 0 && (
            <>
              <p>{section.skippedItemsText}</p>
              <ul>
                {section.skippedItems.map(skipped => (
                  <li key={skipped.id}>
                    {skipped.name}: {skipped.reason}
                  </li>
                ))}
              </ul>
            </>
          )}
        </React.Fragment>
      ))}
    </FormDialog>
  );
}
